<template>
  <div>
    <div class="row">
      <div class="col mb-4">
        <b-pagination
          v-show="totalCount > perPage"
          v-model="currentPage"
          :total-rows="totalCount"
          :per-page="perPage"
          :current-page="currentPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <b-table
          show-empty
          emptyText="Não há itens para exibir"
          striped
          hover
          bordered
          responsive
          :busy="loading"
          :current-page="currentPage"
          :per-page="perPage"
          :items="pedidos"
          :fields="fields"
        >
          <div slot="table-busy" class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Carregando...</strong>
          </div>
          <template slot="[status]" slot-scope="row">
            <b-badge v-if="row.item.vads_trans_status == 'success' || row.item.vads_trans_status == 'paid'" variant="success">Pago</b-badge>
            <b-badge v-else-if="row.item.vads_trans_status == 'waiting'" variant="warning">Aguardando Pagamento</b-badge>
            <b-badge v-else variant="danger">Suspenso</b-badge>
          </template>
          <template slot="[vads_payment_cards]" slot-scope="row">
            <span v-if="!row.item.vads_payment_cards"></span>
            <span v-else-if="row.item.vads_payment_cards.descricao">{{row.item.vads_payment_cards.descricao}}</span>
            <span v-else>{{row.item.vads_payment_cards.tipoPagamento}}</span>
          </template>
          <template slot="[actions]" slot-scope="row">
            <b-button size="sm" @click="view(row)">
              <i class="fas fa-search"></i>
            </b-button>
            <b-button size="sm" @click="edit(row)">
              <i class="fas fa-edit"></i>
            </b-button>
            <b-button size="sm" @click="edit(row)">
              <i class="fas fa-remove"></i>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";

export default {
  data() {
    return {
      pedidos: [],
      perPage: 10,
      currentPage: 1,
      totalCount: 0,
      fields: [
        {
          key: "vads_trans_id",
          label: "Nº Pedido"
        },
        { key: "status", label: "Status", sortable: true },
        /* {
          sortable: true,
          key: "createdAt",
          label: "Data cadastro",
          formatter: value => {
            return moment(value).format("DD/MM/YYYY HH:mm:ss");
          }
        }, */
        {
          key: "client.name",
          label: "Cliente",
          sortable: true
        },
        {
          key: "client.cpf",
          label: "CPF do cliente",
          formatter: value => {
            if (!value) return "";
            if (value.indexOf(".") > 0) {
              return value;
            } else {
              return value.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                "$1.$2.$3-$4"
              );
            }
          }
        },
        {
          sortable: true,
          key: "plano.name",
          label: "Plano"
        },
        {
          sortable: true,
          key: "plano.price",
          label: "Preço"
        },
        {
          sortable: true,
          key: "vads_payment_cards",
          label: "Forma de Pagamento"
        },
        { key: "actions", label: "Ações", class: "text-center" }
      ]
    };
  },
  computed: {
    loading() {
      return this.$store.getters.loadingTable;
    },
    empresa() {
      return this.$store.getters.empresa;
    }
  },
  async mounted() {
    moment.locale("pt-br");

    this.$store.dispatch("setLoadingTable", true);
    const response = await axios.get(
      "/api/saude?sort=-createdAt&limit=100&juridica._id=" + this.empresa._id
    );
    this.$store.dispatch("setLoadingTable", false);

    this.pedidos = response.data;
    this.totalCount = this.pedidos.length;
  }
};
</script>